import pkg from '../package.json';

/** Display version from package.json (Settings + footer). */
export const APP_VERSION = pkg.version;
